<template>
  <svg
    :width="size"
    :height="size"
    :class="['microsoft-icon', `size-${size}`]"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.52381 9.52381H2V2H9.52381V9.52381Z" fill="#F25022" />
    <path d="M18 9.52381H10.4762V2H18V9.52381Z" fill="#7FBA00" />
    <path d="M9.52381 18H2V10.4762H9.52381V18Z" fill="#00A4EF" />
    <path d="M18 18H10.4762V10.4762H18V18Z" fill="#FFB900" />
  </svg>
</template>

<script>
export default {
  name: "MicrosoftIcon",
  props: {
    size: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style scoped lang="scss">
.microsoft-icon {
  display: inline-block;
  flex-shrink: 0;
  /* No per-icon hover — matches WelcomeScreen.tsx (hover is only on the SSO button background) */

  &.size-16 {
    width: 16px;
    height: 16px;
  }

  &.size-20 {
    width: 20px;
    height: 20px;
  }

  &.size-24 {
    width: 24px;
    height: 24px;
  }
}
</style>
